import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "../Components/Axios/Axios";
import { Container, Button, Card, Form, Col, Row } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Components/Sidebar/MainSidebar/Sidebar";
import Loader from "../Components/Spinner/Spinner";
import requests from "../Components/Requests/Requests";
import { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles

function EditFaq(props) {
  const history = useHistory();
  const data = props.location.state;

  const allTypes = ["android", "ios", "macos", "windows", "webapp"];
  const [titles, setTitles] = useState({
    en: "",
    ru: "",
    pt: "",
    de: "",
    fr: "",
    es: "",
    kk: "",
    hi: "",
    "zh-CN": "",
    "zh-TW": "",
    uk: "",
    ar: "",
    tr: "",
    he: "",
    it: "",
    ca: "",
    hr: "",
    cs: "",
    da: "",
    nl: "",
    fi: "",
    el: "",
    hu: "",
    no: "",
    pl: "",
    ro: "",
    sk: "",
    sv: "",
    ko: "",
    th: "",
    vi: "",
    ja: "",
    id: "",
    ms: "",
  });
  const [title, setTitle] = useState("");
  const [transData, setTransData] = useState({});
  const [descriptions, setDescriptions] = useState({});

  const [icon, setIcon] = useState("");

  const [loading, setLoading] = useState(false);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const LANGUAGES = [
    { key: "english", label: "English", code: "en" },
    { key: "russian", label: "Russian", code: "ru" },
    { key: "portuguese", label: "Portuguese", code: "pt" },
    { key: "german", label: "German", code: "de" },

    { key: "french", label: "French", code: "fr" },
    { key: "spanish", label: "Spanish", code: "es" },
    { key: "kazakh", label: "Kazakh", code: "kk" },
    { key: "hindi", label: "Hindi", code: "hi" },

    { key: "chinese_simplified", label: "Chinese (Simplified)", code: "zh-CN" },
    {
      key: "chinese_traditional",
      label: "Chinese (Traditional)",
      code: "zh-TW",
    },

    { key: "ukrainian", label: "Ukrainian", code: "uk" },
    { key: "arabic", label: "Arabic", code: "ar" },
    { key: "turkish", label: "Turkish", code: "tr" },
    { key: "hebrew", label: "Hebrew", code: "he" },

    { key: "italian", label: "Italian", code: "it" },
    { key: "catalan", label: "Catalan", code: "ca" },
    { key: "croatian", label: "Croatian", code: "hr" },
    { key: "czech", label: "Czech", code: "cs" },

    { key: "danish", label: "Danish", code: "da" },
    { key: "dutch", label: "Dutch", code: "nl" },
    { key: "finnish", label: "Finnish", code: "fi" },
    { key: "greek", label: "Greek", code: "el" },

    { key: "hungarian", label: "Hungarian", code: "hu" },
    { key: "norwegian", label: "Norwegian", code: "no" },
    { key: "polish", label: "Polish", code: "pl" },
    { key: "romanian", label: "Romanian", code: "ro" },

    { key: "slovak", label: "Slovak", code: "sk" },
    { key: "swedish", label: "Swedish", code: "sv" },
    { key: "korean", label: "Korean", code: "ko" },
    { key: "thai", label: "Thai", code: "th" },

    { key: "vietnamese", label: "Vietnamese", code: "vi" },
    { key: "japanese", label: "Japanese", code: "ja" },
    { key: "indonesian", label: "Indonesian", code: "id" },
    { key: "malay", label: "Malay", code: "ms" },
  ];

  // const handleCheckboxChange = (e) => {
  //   const value = e.target.value;

  //   let updated = [...selectedTypes];

  //   if (updated.includes(value)) {
  //     updated = updated.filter((item) => item !== value);
  //   } else {
  //     updated.push(value);
  //   }

  //   setSelectedTypes(updated);
  // };

  const addNewFaq = async () => {
    // const formData = new FormData();
    // formData.append("id", id);
    // formData.append("que", title);
    // formData.append("ans", editorValue);

    // formData.append("status", status);
    // formData.append("type",type);
    if (window.navigator.onLine) {
      setLoading(true);
      const formData = new FormData();

      formData.append("titles", JSON.stringify(titles));

      const body = {
        titles: JSON.stringify(titles),
      };
      try {
        const responce = await axios.post(requests.addCategory, body);
        // console.log("result........",responce);
        if (responce.data.Success === 1) {
          // console.log(responce);
          toast.success("Category editted successfully!!", {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setTimeout(() => {
            history.push("/allLessonCategories");
          }, 2500);
        } else {
          setLoading(false);
          toast.warning(`Something went wrong`, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (err) {
        toast.warning(err, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      // console.log("body.....", body);
    } else {
      toast.error(`No internet connection`, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  return (
    <>
      <Sidebar />
      <Container className="content">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Card>
          <Card.Header className="heading">Edit Category</Card.Header>
          <Card.Body>
            <Row>
              <Col className="main">
                {LANGUAGES.map((lang) => {
                  const t = transData[lang.code] || {};

                  return (
                    <div key={lang.code}>
                      {/* Title */}
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Name{" "}
                          {lang.code === "en" ? (
                            <span className="mandatory">*</span>
                          ) : (
                            ""
                          )}
                          ({lang.code})
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder={`Name in ${lang.label}`}
                          value={titles[lang.code] || ""} // all values stored here
                          onChange={(e) => {
                            const value = e.target.value;

                            // 1️⃣ Update unified titles state
                            setTitles((prev) => ({
                              ...prev,
                              [lang.code]: value,
                            }));

                            // 2️⃣ English name → update existing main title

                            // 3️⃣ Non-English → update translation data
                          }}
                        />
                      </Form.Group>
                    </div>
                  );
                })}
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="footer">
            {loading == true ? (
              <Loader margin={0} />
            ) : (
              <Button
                className="submit-btn"
                onClick={() => addNewFaq()}
                variant="primary"
              >
                Submit
              </Button>
            )}
          </Card.Footer>
        </Card>
      </Container>
    </>
  );
}

export default EditFaq;
